// extracted by mini-css-extract-plugin
export default {"box":"styles_box__ec8Gz","isSelected":"styles_isSelected__V9f4J"};